function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#ffb90b"
    },
    d: "M100 50c0-27.6-22.4-50-50-50S0 22.4 0 50s22.4 50 50 50 50-22.4 50-50z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#ffb90b"
    },
    cx: 50,
    cy: 50,
    r: 37.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M52.7 70.9s-8.1-8.7.2-22.9c7.9-14.7-3.8-19-3.8-19s3.7 7.6-2.5 16.4c-7.2 10.2 6.1 25.5 6.1 25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M40.5 70.9s-8.5-8.7.2-22.9c8.3-14.7-4-19-4-19s3.8 7.6-2.6 16.4c-7.5 10.2 6.4 25.5 6.4 25.5zM65.1 70.9s-8.5-8.7.2-22.9c8.3-14.7-4-19-4-19s3.8 7.6-2.6 16.4c-7.5 10.2 6.4 25.5 6.4 25.5z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGas);
export default __webpack_public_path__ + "static/media/gas.03eb2ef1666c82f3c32bb2961c245d7b.svg";
export { ForwardRef as ReactComponent };